import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { LanguageService } from '@core/services/language/language.service';
import { Observable } from 'rxjs';
import { ApiResponse } from '@interfaces/api/api.interface';

@Injectable({
  providedIn: 'root',
})
export class BlogService {
  private http = inject(HttpClient);
  private getArticlesEndpoint = environment.endpoints.blog.articles;
  private api = environment.BLOG_API_URL;
  private locale = inject(LanguageService);
  // el any esta ahi porque aun no he logrado que me responda este endpoint para ver el tipo de su respuesta
  public getArticles(): Observable<ApiResponse<any>> {
    // let httpParams = new HttpParams();
    // httpParams = httpParams.set('locale', this.locale.getCurrentLanguage().toUpperCase());
    return this.http.get<ApiResponse<any>>(`${this.api}/${this.getArticlesEndpoint}`);
  }
}
